import { getHealthServices } from './fetch/getHealthServices'

class HealthServicesService {
  getFetchHealthServices = getHealthServices
}

export const healthService = new HealthServicesService()
